import { createStore } from 'jotai';

const regionStore = createStore();

export { regionStore };
